import './SearchCasinoGameItem.less';

import CasinoGameImg from '@/casinovegas/views/CasinoGameImg';
import React from 'react';
import { highlightText } from '@/fullsearch/views/SearchView';
import SearchBoxTable from '@/fullsearch/views/SearchBoxTable';

function SearchCasinoGameItem({ gameId, gameName, gameAnotation, redirectFunction, searchedText }) {
    return (
        <SearchBoxTable onClick={redirectFunction} className={''}>
            <CasinoGameImg gameId={gameId} alt={gameName} className={'search-casino-game-img'} />
            <div className="search-casino-game-description fs-14 flex flex-col justify-between px-10 py-10">
                <div className="casino-game-title">{highlightText(gameName, searchedText)}</div>
                <div className="casino-game-text">{highlightText(gameAnotation, searchedText)}</div>
            </div>
        </SearchBoxTable>
    );
}

export default SearchCasinoGameItem;
